import * as React from 'react';
import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    H2Emphasized,
    InfoRow,
    RowList,
    YStack,
} from 'smoothie';

import { type Card, CardForm } from '../../../../types/Card';
import FruitfulCard from '../../FruitfulCard';

interface TerminateCardProps {
    card: Card;
    onPress: () => void;
}

const TerminateCard = ({ card, onPress }: TerminateCardProps) => {
    const { lastFour, embossName } = card;

    return (
        <YStack flex={1} justifyContent="space-between">
            <YStack>
                <FruitfulCard
                    cardholderName={embossName.line1}
                    width={316}
                    form={CardForm.PHYSICAL}
                    lastFour={lastFour}
                    alignSelf="center"
                    marginBottom={40}
                />

                <H2Emphasized textAlign="center" marginBottom={12}>
                    Cancel this card
                </H2Emphasized>

                <BodyMediumRegular
                    textAlign="center"
                    color="$gray1000"
                    marginBottom={32}
                >
                    This will prevent unauthorized purchases on{'\n'} your lost
                    or stolen card.
                </BodyMediumRegular>
                <RowList>
                    <InfoRow title="Card holder" value={embossName.line1} />
                    <InfoRow title="Card number" value={`*${lastFour}`} />
                </RowList>
            </YStack>

            <Button
                onPress={onPress}
                size={ButtonSize.LARGE}
                variant={ButtonVariant.PRIMARY}
                tone="danger"
                text="Cancel card"
            />
        </YStack>
    );
};

export default TerminateCard;
